import styled from '../theme/styled-components';

export const BrandTitle = styled.h2`
  color: ${props => props.theme.colors.typography.light.base};
  font-size: ${props => props.theme.typography.brandTitle.fontSize};
  font-weight: ${props => props.theme.typography.brandTitle.fontWeight};
  font-family: ${props => props.theme.typography.brandTitle.fontFamily};
  letter-spacing: ${props => props.theme.typography.brandTitle.letterSpacing};
  line-height: ${props => props.theme.typography.brandTitle.lineHeight};
  margin-bottom: 0;

  ${media => media.theme.media.between('medium', 'downLarge')`
   font-size: calc(${props =>
     props.theme.typography.brandTitle.fontSize} * .65);
     line-height: calc(${props =>
       props.theme.typography.brandTitle.lineHeight} * .65);
  `}
`;

export const BrandTagline = styled.span`
  color: ${props => props.theme.colors.typography.light.base};
  font-size: ${props => props.theme.typography.brandTagline.fontSize};
  font-weight: ${props => props.theme.typography.brandTagline.fontWeight};
  font-family: ${props => props.theme.typography.brandTitle.fontFamily};
  letter-spacing: ${props => props.theme.typography.brandTagline.letterSpacing};
  text-transform: uppercase;

  ${media => media.theme.media.between('medium', 'downLarge')`
    font-size: calc(${props =>
      props.theme.typography.brandTagline.fontSize} * .65);
  `}
`;
